import { render, staticRenderFns } from "./TagFormModalV2026.vue?vue&type=template&id=6bf3f8ea&scoped=true"
import script from "./TagFormModalV2026.vue?vue&type=script&lang=js"
export * from "./TagFormModalV2026.vue?vue&type=script&lang=js"
import style0 from "./TagFormModalV2026.vue?vue&type=style&index=0&id=6bf3f8ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf3f8ea",
  null
  
)

export default component.exports